<template>
    <section class="text-white">
        <b-container class="">
            <b-row>
                <b-col sm="12" md="12" lg="12" style="margin-top: 120px;">
                    <h1 class="text-left font-weight-bold">
                        <span>PREMIOS</span>
                    </h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="container-img" sm="12" md="6" lg="6">
                    <img style="width: 100%" src="../assets/img/5.png"/>
                    <div class="middle">
                        <div class="text">
                            <br/><br/><br/><br/>
                            Mejor campaña social.

                        </div>
                    </div>
                </b-col>
                <b-col class="container-img" sm="12" md="6" lg="6">
                    <img style="width: 100%" src="../assets/img/4.png"/>
                    <div class="middle">
                        <div class="text">
                            <br/><br/><br/><br/>

                            Por el éxito obtenido de la campaña, manejando estrategias
                            para la baja demanda del servicio por parte de las nuevas generaciones.
                        </div>
                    </div>
                </b-col>
                <b-col class="container-img" sm="12" md="6" lg="6">
                    <img style="width: 100%" src="../assets/img/2.png"/>
                    <div class="middle">
                        <div class="text">
                            <br/><br/><br/><br/>
                            Ganador por generar impacto en el público objetivo, consentizando
                            el abuso del alcohol al momento de conducir irresponsablemente.
                        </div>
                    </div>
                </b-col>
                <b-col class="container-img" sm="12" md="6" lg="6">
                    <img style="width: 100%" src="../assets/img/1.png"/>
                    <div class="middle">
                        <div class="text">
                            <br/><br/><br/><br/>
                            Premio otorgado por motivar a los torreonences al cumplir con
                            su responsabilidad al pago del predial de una forma consiente y cálida.
                        </div>
                    </div>
                </b-col>
                <b-col class="container-img" sm="12" md="6" lg="6">
                    <img style="width: 100%" src="../assets/img/3.png"/>
                    <div class="middle">
                        <div class="text">
                            <br/><br/><br/><br/>
                            Acreedor a este premio por la original adaptación a la
                            imagen tradicional del político, transmitiendo un mensaje
                            sólido e identificando a la cidadanía.
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>

    export default {
        name: "Awards",

    }
</script>

<style scoped>
    .image {
        opacity: 1;
        display: block;
        width: 100%;
        height: auto;
        transition: .5s ease;
        backface-visibility: hidden;
    }

    .middle {
        transition: .5s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        height: 251px;
    }

    .container-img:hover .image {
        opacity: 0.3;
    }

    .container-img:hover .middle {
        opacity: 1;
    }

    .text {
        background-color: rgba(43, 44, 46,.8);
        color: white;
        font-size: 16px;
        height: inherit;
    }
</style>
